<template>
  <ion-page>
    <ion-header>
      <ion-toolbar>
        <ion-title v-if="loading">...</ion-title>
        <ion-title v-else>{{ t('OrderPage.order') }} #{{ order.id }}</ion-title>
        <ion-buttons slot="start">
          <ion-back-button default-href="/orders"></ion-back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content :fullscreen="true">
      <!-- Loading Data -->
      <div class="spin" v-if="loading">
        <ion-spinner></ion-spinner>
      </div>

      <ion-grid fixed v-else>
        <ion-row class="ion-justify-content-center">
          <ion-col size="12" size-md="8" size-lg="6">
            <ion-list>
              <ion-item>
                <ion-label>{{ t('OrderPage.orderStatus') }}</ion-label>
                <ion-badge :color="getOrderStatusColor(order.status)">
                  {{ order.status }}
                </ion-badge>
              </ion-item>
              <ion-list-header color="primary">
                {{ t('OrderPage.orderItems') }}
              </ion-list-header>
              <div class="ion-text-center" v-if="loadingOrderItems">
                <ion-spinner></ion-spinner>
              </div>
              <div v-else>
                <ion-item v-for="item in orderItems" :key="item.productId">
                  <ion-thumbnail v-if="item.productImage" slot="start">
                    <img :src="item.productImage">
                  </ion-thumbnail>
                  <ion-label class="ion-text-wrap">
                    <h3>
                      {{ item.quantity }} x {{ item.productName }}
                    </h3>
                    <p>HK${{ Number(item.unitPrice).toLocaleString() }} / 1</p>
                    <p>{{ t('OrderPage.lineTotal') }}HK${{ Number(item.unitPrice * item.quantity).toLocaleString() }}</p>
                  </ion-label>
                </ion-item>
                <ion-item>
                  <ion-label><b>{{ t('OrderPage.orderTotal') }}HK$ {{ Number(order.totalPrice).toLocaleString() }}</b></ion-label>
                </ion-item>
              </div>
            </ion-list>

            <ion-list>
              <ion-list-header color="primary">
                {{ t('OrderPage.deliveryInfo') }}
              </ion-list-header>
              <ion-item>
                <ion-label>{{ t('deliveryMethod') }} {{ order.deliveryMethod }}</ion-label>
              </ion-item>
              <ion-item v-show="order.deliveryMethod == '送貨上門'">
                <ion-label>{{ t('deliveryDistrict') }}{{ order.deliveryDistrict }}</ion-label>
              </ion-item>
              <ion-item>
                <ion-label>{{ t('deliveryAddress') }}{{ order.deliveryAddress }}</ion-label>
              </ion-item>
              <ion-item>
                <ion-label>{{ t('customerName') }}{{ order.customerName }}</ion-label>
              </ion-item>
              <ion-item>
                <ion-label>{{ t('contactPhone') }}{{ order.contactPhone }}</ion-label>
              </ion-item>
              <ion-item>
                <ion-label>{{ t('customerEmail') }}{{ order.customerEmail }}</ion-label>
              </ion-item>
            </ion-list>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script lang="ts">

import { IonPage, IonHeader, IonToolbar, IonTitle, IonContent,
        IonGrid, IonCol, IonRow, IonSpinner, IonButtons, IonButton, IonIcon, IonBackButton,
        IonItem, IonLabel, } from '@ionic/vue';

import { ref } from 'vue';

// icons
import { location } from 'ionicons/icons';

// services
import OrderService from '@/services/OrderService';
import { useRoute } from 'vue-router';

import { utils } from '@/composables/utils';
import { useI18n } from 'vue-i18n';

export default {
  name: 'OrderDetailPage',
  components: { IonHeader, IonToolbar, IonTitle, IonContent, IonPage,
                IonGrid, IonCol, IonRow, IonSpinner, IonButtons, IonButton, IonIcon, IonBackButton,
                IonItem, IonLabel },
  setup() {
    const loading = ref(true);
    const loadingOrderItems = ref(false);
    const orderItems = ref<any>(null);
    const order = ref<any>(null);

    // methods
    const { t } = useI18n();
    const { getOrderStatusColor } = utils();
    const route = useRoute();
    const passedOrder: any = route.params.passedOrder; // route paramters (mainly ID)
    if (passedOrder) { // from cart page
      loading.value = false;
      loadingOrderItems.value = true;
      order.value = JSON.parse(passedOrder);
      OrderService.getOrderItems(order.value.id).then(res => {
        loadingOrderItems.value = false;
        orderItems.value = res;
      });
    } else {
      // fetch both order & order items
      OrderService.getOrderById(route.params.id).then(res => {
        loading.value = false;
        order.value = res;
        orderItems.value = res.items;
      });
    }
  
    return {
      t,

      // icons
      location,
      
      // methods
      getOrderStatusColor,

      // variables
      loading, loadingOrderItems, order, orderItems,
    }
  },
}
</script>

<style scoped>
</style>